import React, { useContext, useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import moment from 'moment';

import '../../index.css';
import AuthContext from '../../contexts/AuthContext';
import ShopModeContext from '../../contexts/ShopModeContext';
import PaymentTable from '../../components/PaymentTable';
import Pagination from '../../components/Pagination';
import icBack from '../../icons/ic-back.svg';
import usePaymentStatus from '../../hooks/usePaymentStatus';
import { getInicisPaymentList, getUserDetail } from '../../modules/NetworkFunction';

function MyPaymentList() {
  const { auth } = useContext(AuthContext);
  const { shopMode } = useContext(ShopModeContext);

  const location = useLocation();
  const { userNo } = location.state;
  console.log(userNo);

  const [prevDate, setPrevDate] = useState(
    moment().subtract(1, 'M').format('YYYY-MM-DD')
  );
  const [nextDate, setNextDate] = useState(moment().format('YYYY-MM-DD'));

  const [currentPage, setCurrentPage] = useState(1);
  const itemPerPage = 8;

  const { filteredPaymentData, getPaymentsByDate, totalPaymentCount } =
    usePaymentStatus(auth, userNo);

  const [makeShopPaymentData, setMakeShopPaymentData] = useState([]);

  useEffect(() => {
    if (prevDate !== '' && nextDate !== '') {
      getPaymentsByDate(prevDate, nextDate, currentPage);
    }
  }, [prevDate, nextDate, getPaymentsByDate, currentPage]);

  useEffect(() => {
    setCurrentPage(1);
  }, [prevDate, nextDate]);

  useEffect(() => {
    console.log(shopMode)
    
      //getPaymentsByDate(prevDate, nextDate, currentPage);
      getInicisPaymentList(
        {
          startDate: prevDate,
          endDate: nextDate,
          userNo: location.state.userNo,
        }, 
        (v) => {
          console.log(v);
          setMakeShopPaymentData(v.paymentList);
        },
        () => {},
        (e) => {
          console.log(e);
        },
        auth
      )

    

  }, [shopMode, prevDate, nextDate])

  return (
    <div>
      <div
        style={{
          paddingTop: '20px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Link
            to="/mypage/payment"
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <img alt="뒤로 가기" src={icBack}></img>
          </Link>
          <span style={{ fontSize: 30, marginLeft: 15 }}>결제 내역</span>
        </div>
        <p style={{ color: '#B5B5B5', fontSize: 16 }}>
          <Link to="/mypage/payment">결제 관리</Link>
          {' >'} 결제 내역
        </p>
      </div>
      <hr
        style={{
          backgroundColor: '#848484',
          height: 0.5,
          border: 0,
          margin: '15px 0px',
        }}
      />
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 30 }}>
        <p
          style={{
            fontWeight: '400',
            fontSize: '16px',
            color: '#B5B5B5',
            marginRight: 15,
          }}
        >
          조회 기간
        </p>

        <input
          type="date"
          value={prevDate}
          onChange={(event) => {
            setPrevDate(event.target.value);
          }}
          max={nextDate}
          // cafe24 결제 api: 90일 이전까지 조회 가능
          min={moment().subtract(90, 'days').format('YYYY-MM-DD')}
        />

        <p
          style={{
            margin: '10px 10px',
            color: '#CCCCCC',
          }}
        >
          ~
        </p>

        <input
          type="date"
          value={nextDate}
          onChange={(event) => {
            setNextDate(event.target.value);
          }}
          min={prevDate}
          max={moment().format('YYYY-MM-DD')}
        />
      </div>

      <div className="inner-box">
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
          }}
        ></div>

        <div
          style={{
            overflow: 'hidden',
            border: '1px solid #CCC',
            borderRadius: 5,
            width: 750,
            marginBottom: 22,
          }}
        >
          <PaymentTable payments={filteredPaymentData} rowCount={itemPerPage} />
        </div>
      </div>

      <div
        style={{
          position: 'absolute',
          bottom: 70,
          left: '50%',
          transform: 'translateX(-50%)',
        }}
      >
        <Pagination
          itemsPerPage={itemPerPage}
          totalItems={totalPaymentCount}
          paginate={setCurrentPage}
          currentPage={currentPage}
        />
      </div>
    </div>
  );
}

export default MyPaymentList;
